const AppDownload = resolve => {
    import(/* webpackChunkName: 'appDownload' */'../views/app/download').then(appDownload => {
        resolve(appDownload)
    })
}

const AppGuid = resolve => {
    import(/* webpackChunkName: 'appDownload' */'../views/app/guid').then(appDownload => {
        resolve(appDownload)
    })
}

const CancelAccount = resolve => {
    import(/* webpackChunkName: 'cancelAccount' */'../views/app/cancelAccount').then(cancelAccount => {
        resolve(cancelAccount)
    })
}
const LandingLYCF = resolve => {
    import(/* webpackChunkName: 'landingLYCF' */'../views/app/landing').then(landingLYCF => {
        resolve(landingLYCF)
    })
}
export default [
    {
        path: '/app',
        redirect: 'app/download',
    },
    {
        path: '/app/download',
        name: 'appDownload',
        component: AppDownload
    },
    {
        path: '/app/guid',
        name: 'appGuid',
        component: AppGuid
    },
    {
        path: '/app/landing/lycf',
        name: 'landingLYCF',
        component: LandingLYCF
    },
    {
        path: '/app/cancelAccount',
        name: 'cancelAccount',
        component: CancelAccount,
        meta: {
            title: '注销说明'
        }
    }
]
